import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { DiscussionRoutingModule } from './discussion-routing.module';
import { AddComponent } from './add/add.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatMenuModule } from '@angular/material/menu';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { NgSelectModule } from '@ng-select/ng-select';
import { NgxDatatableModule } from '@swimlane/ngx-datatable';
import { PipeModule } from 'app/shared/pipes/pipe.module';
import { NgxSpinnerModule } from 'ngx-spinner';
import { NgxMaskModule } from 'ngx-mask';
import { ListForStudentComponent } from './list-for-student/list-for-student.component';
import { ListAdminComponent } from './list-admin/list-admin.component';


@NgModule({
  declarations: [
    AddComponent,
    ListForStudentComponent,
    ListAdminComponent,
  ],
  imports: [
    CommonModule,
    DiscussionRoutingModule,
    FormsModule,
    ReactiveFormsModule,
    NgSelectModule,
    NgbModule,
    PipeModule,
    NgxDatatableModule, 
    NgxSpinnerModule,
    MatMenuModule,
    NgxMaskModule.forRoot(),

  ],
  schemas:[CUSTOM_ELEMENTS_SCHEMA]
})
export class DiscussionModule { }
